import { EEstateType } from 'shared/types/filters/advanced/estateType';

export const estateTypeMapLabel: Record<EEstateType, string> = {
  [EEstateType.Rent]: 'В аренде',
  [EEstateType.Owned]: 'В собственности',
};
